import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getActivityLog = createAsyncThunk(
  "activityLog/getActivityLog",
  async ({ module, entityId, orgId, page, limit, dealCategoryId, dealId }, { rejectWithValue }) => {
    try {
      let url = `/api/admin/getActivityLog?module=${module}&entityId=${entityId}&page=${page}&limit=${limit}`;
      if (orgId) {
        url += `&orgId=${orgId}`;
      }
      if (dealCategoryId) {
        url += `&dealCategoryId=${dealCategoryId}`;
      }
      if (dealId) {
        url += `&dealId=${dealId}`;
      }
      const response = await axios.get(url);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

const initialState = {
  logs: [],
  loading: false,
  error: null,
  totalRecords: 0,
};

const activityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
    clearActivityLog: (state) => {
      state.logs = [];
      state.loading = false;
      state.error = null;
      state.totalRecords = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityLog.fulfilled, (state, action) => {
        state.loading = false;
        const responseData = action.payload?.data || action.payload || {};
        const resData = responseData.response;
        if (Array.isArray(resData)) {
          state.logs = resData;
          state.totalRecords = responseData.totalRecords !== undefined ? responseData.totalRecords : resData.length;
        } else if (resData && Array.isArray(resData.rows)) {
          state.logs = resData.rows;
          state.totalRecords = responseData.totalRecords !== undefined ? responseData.totalRecords : (resData.count || 0);
        } else {
          state.logs = Array.isArray(responseData.logs) ? responseData.logs : [];
          state.totalRecords = responseData.totalRecords || 0;
        }
      })
      .addCase(getActivityLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearActivityLog } = activityLogSlice.actions;

export default activityLogSlice.reducer;
